module.exports = __webpack_public_path__ + "img/Animod Giftbox.cfa7215.png";